<template>
  <div class="Index">
    <div class="header">
      <div class="title"></div>
      <!-- <div class="img"></div> -->
    </div>
    <div v-if="!big">
      <div class="Btn">
        <div class="btuBg" v-if="isWechat" @click.stop="goImg">分享给好友</div>
        <div class="btuBg" @click.stop="goRegister">再次体验</div>
        <div class="btuBg" @click.stop="goIndex">返回首页</div>
      </div>
      <div class="box">
        <div
          class="box_left"
          v-show="userInfoMsg.msg === 'wx' || userInfoMsg.msg === 'zfb'"
        >
          <div class="left_top">您还可以学习：</div>
          <div class="left_bto">
            <div
              class="item"
              v-for="(item, index) in learnItems"
              :key="index"
              @click.stop="goBranch(item.path)"
            >
              <div class="finger"></div>
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
        <div class="box_right">
          <img src="@/assets/qr_code.png" alt="" />
          <div class="right_text">
            <div>扫码关注公众号</div>
            <div>更多精彩等你发现</div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="Btn2">
        <div class="btuBg" @click.stop="goRegister">再次体验</div>
        <div class="btuBg" @click.stop="goIndex">返回首页</div>
      </div>
      <div
        class="box2"
        v-show="userInfoMsg.msg === 'wx' || userInfoMsg.msg === 'zfb'"
      >
        <div class="top">您还可以学习：</div>
        <div class="bto">
          <div
            class="item"
            v-for="(item, index) in learnItems"
            :key="index"
            @click.stop="goBranch(item.path)"
          >
            <div class="finger"></div>
            <div class="text">{{ item.text }}</div>
          </div>
        </div>
      </div>
      <div class="QRcode">
        <!-- <div class="QRcode_box">
          <img src="@/assets/qr_code1.png" alt="" />
          <div class="text">扫码带走随时体验</div>
        </div> -->
        <div class="QRcode_box">
          <img src="@/assets/qr_code.png" alt="" />
          <div class="text">关注公众号体验更多</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'registerOver',
  data () {
    return {
      big: false,
      learnItems: [],
      isWechat: false,
      isMobileDevice:
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
    }
  },
  computed: {
    userInfoMsg: function () {
      return this.$store.getters.userInfo
    },
    userInfoTitle: function () {
      return this.$store.getters.navTitle
    }
  },
  created () {
    this.learnItems = this.$store.getters.userInfo.branchItems
  },
  mounted () {
    // 检测是否是微信浏览器
    const userAgent = navigator.userAgent.toLowerCase()
    this.isWechat = /micromessenger/.test(userAgent)
  },
  beforeDestroy () {},

  methods: {
    goImg () {
      this.$router.push({
        path: '/end/end2'
      })
    },
    goBranch (path) {
      this.$router.push({ path })
    },
    goRegister () {
      this.$store.commit('setIsAgainTitle', { title: this.userInfoTitle })
      this.$router.push({
        path: this.$store.getters.userInfo.againPath
      })
    },
    goIndex () {
      // 页面后不允许返回上一页
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>

<style scoped lang="less">
.Index {
  position: relative;
  width: 100%;
  height: 100%;
  background: url("@/assets/end/overBg.png") no-repeat center;
  background-size: 100% 100%;
  border-radius: 0px;
}
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 4.5vh;
  left: 50%;
  transform: translate(-50%);

  .title {
    width: 100vw;
    height: 160px;
    background: url(@/assets/end/end_title.png) no-repeat top;
    background-size: 100% 100%;
  }
  // .img {
  //   // margin-top: 30px;
  //   position: absolute;
  //   top: 12.5vh;
  //   left: 50%;
  //   transform: translate(-50%);
  //   width: 280px;
  //   height: 323px;
  //   background: url(@/assets/end/end_img.png) no-repeat center;
  //   background-size: 100% 100%;
  // }
}
.Btn {
  position: absolute;
  top: 43vh;
  left: 50%;
  height: 25vh;
  transform: translate(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .btuBg {
    width: 400px;
    padding: 15px 0px;
    // height: 89px;
    background: url(@/assets/end/longButton.png) no-repeat center;
    border-radius: 96.5px;
    box-shadow: inset 0px 0px 12px 5px rgba(253, 174, 125, 0.25),
      0px 6px 12px 1px rgba(166, 89, 89, 0.27);
    background-size: 100% 100%;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 42px;
    color: #ffffff;
    margin-bottom: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.Btn2 {
  position: absolute;
  top: 40vh;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  .btuBg {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 100px;
    background: url(@/assets/end/longButton.png) no-repeat center;
    background-size: 100% 100%;
    font-family: Microsoft YaHei;
    font-weight: bold;
    font-size: 36px;
    color: #ffffff;
  }
  .btuBg:first-child {
    margin-right: 30px;
  }
}
.box {
  position: absolute;
  top: 71vh;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 688px;
  min-height: 314px;
  max-height: 350px;
  background: rgba(255, 255, 255, 0.79);
  border-radius: 30px;
  border: 4px solid #ffffff;
  .box_left {
    .left_top {
      font-family: Alimama;
      font-weight: bold;
      font-size: 40px;
      color: #000000;
      // line-height: 65px;
      // margin-bottom: 40px;
    }
    .left_bto {
      .item {
        display: flex;
        align-items: center;
         margin-top: 20px;
        // &:last-child {
        //   .text {
        //     margin-bottom: 0px;
        //   }
        // }
        .finger {
          width: 52px;
          height: 32px;
          background: url(@/assets/end/end_finger.png) no-repeat center;
          background-size: 100% 100%;
          margin-right: 10px;
        }
        .text {
          font-family: Alimama;
          font-weight: bold;
          font-size: 30px;
          color: #333333;
          line-height: 40px;
          text-decoration-line: underline;
          width: 52vw;
          // &:first-child {
          //   margin-bottom: 20px;
          // }

        }
      }
    }
  }
  .box_right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    img {
      width: 161px;
      height: 162px;
    }
    .right_text {
      text-align: center;
      margin-top: 10px;
      font-family: Alibaba-PuHuiTi-M;
      font-weight: 500;
      font-size: 24px;
      color: #000000;
      line-height: 33px;
    }
  }
}
.box2 {
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translate(-50%);
  display: flex;
  flex-direction: column;
  .top {
    font-family: Alimama;
    font-weight: bold;
    font-size: 40px;
    color: #000000;
    line-height: 65px;
    margin-bottom: 20px;
    margin-left: 30px;
  }
  .bto {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    width: 649px;
    height: 241px;
    background: linear-gradient(0deg, #ffffff 0%, #fff1e3 100%);
    border-radius: 30px;
    border: 4px solid #ffffff;
    .item {
      display: flex;
      align-items: center;
      padding-left: 40px;
      .finger {
        width: 67px;
        height: 41px;
        background: url(@/assets/end/end_finger.png) no-repeat center;
        background-size: 100% 100%;
        margin-right: 10px;
      }
      .text {
        font-family: Alimama;
        font-weight: bold;
        font-size: 36px;
        color: #333333;
        line-height: 65px;
        text-decoration-line: underline;
        width: 52vw;
      }
    }
  }
}
.QRcode {
  position: absolute;
  top: 78vh;
  left: 50%;
  transform: translate(-50%);
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.QRcode_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  img {
    width: 200px;
    height: 200px;
  }
  .text {
    text-align: center;
    font-family: Alibaba-PuHuiTi-M;
    font-weight: 500;
    font-size: 30px;
    color: #000000;
    line-height: 60px;
  }
}
</style>
